"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FaqSection = void 0;
var faq_1 = require("./faq");
Object.defineProperty(exports, "FaqSection", { enumerable: true, get: function () { return faq_1.FaqSection; } });
